import _ from 'lodash';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../NotificationPopUp';

import commonFunctions from '../../../commonFunctions';

import SelectInput from '../../common/SelectInput';
import TextInput from '../../common/TextInput';

import * as authenticationActions from '../../../actions/authenticationActions';
import * as userActions from '../../../actions/userActions';

class UsersPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        const appR = commonFunctions.allRoles();
        appR.unshift({ value: -1, text: '---' });

        this.state = {
            authenticationState: this.props.authenticationState,
            commonState: this.props.commonState,
            pagingModel: this.props.pagingModel,
            roles: appR
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history))
            return;

        this.redirectToUserPage = this.redirectToUserPage.bind(this);
        this.gridOnRowClick = this.gridOnRowClick.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.search = this.search.bind(this);
        this.userInsertButton = this.userInsertButton.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
    }

    componentDidMount() {
        if (this.state.pagingModel.items === null || this.state.pagingModel.items.length === 0) {
            this.search();
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.authenticationState !== prevState.authenticationState || nextProps.commonState !== prevState.commonState ||
            nextProps.pagingModel !== prevState.pagingModel) {
            const appPaginModel = Object.assign({}, prevState.pagingModel,
                {
                    items: nextProps.pagingModel.items,
                    page: nextProps.pagingModel.page,
                    itemsPerPage: nextProps.pagingModel.itemsPerPage,
                    total: nextProps.pagingModel.total
                });
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState, pagingModel: appPaginModel });
        }
        return null;
    }

    redirectToUserPage() {
        this.props.history.push('/user');
    }

    onPageChange(page, sizePerPage) {
        var nPaging = Object.assign({}, this.state.pagingModel, { page: page, itemsPerPage: sizePerPage });
        this.search(nPaging);
    }

    onSortChange(sortName, sortOrder) {
        var nPaging = Object.assign({}, this.state.pagingModel, { sortName: sortName, sortOrder: sortOrder });
        this.search(nPaging);
    }

    search(pagingModel) {
        if (_.isNil(pagingModel))
            pagingModel = this.state.pagingModel;

        this.props.userActions.loadUsers(pagingModel).then(() => {
        }).catch(error => {
            notificationPopUp.error('Problemi nel caricamento degli Utenti');
        });
    }

    gridOnRowClick(row) {
        this.props.history.push('/user/' + row.id);
    }

    roleInString(cell, row) {
        return commonFunctions.roleInString(cell);
    }

    userInsertButton() {
        return (<button type="button" className="btn btn-info react-bs-table-add-btn" onClick={this.redirectToUserPage}>
            <span><i className="glyphicon glyphicon-plus"></i> Crea Utente</span>
        </button>);
    }

    updateFilters(event) {
        const pagingModel = Object.assign({}, this.state.pagingModel);
        if (event.target.name === 'roleId')
            pagingModel[event.target.name] = parseInt(event.target.value, 10);
        else
            pagingModel[event.target.name] = event.target.value;
        this.setState(Object.assign({}, this.state, { pagingModel }));
    }

    render() {
        const gridOptions = {
            sizePerPage: this.state.pagingModel.itemsPerPage,
            page: this.state.pagingModel.page,
            sizePerPageList: [5, 10, 20, 50],
            onRowClick: this.gridOnRowClick,
            onPageChange: this.onPageChange,
            onSortChange: this.onSortChange,
            insertBtn: this.userInsertButton
        };

        return (
            <div className='container-fluid'>
                <h1>Gestione Utenti</h1>
                <div className="row panel panel-default x-panel-gray">
                    <div className="panel-heading">Filtri</div>
                    <div className="panel-body">
                        <Row>
                            <Col xs={12} md={3}>
                                <TextInput
                                    label='Nome'
                                    name='name'
                                    onChange={this.updateFilters}
                                    value={this.state.pagingModel.name} />
                            </Col>
                            <Col xs={12} md={3}>
                                <TextInput
                                    label='Cognome'
                                    name='surname'
                                    onChange={this.updateFilters}
                                    value={this.state.pagingModel.surname} />
                            </Col>
                            <Col xs={12} md={3}>
                                <TextInput
                                    label='Username'
                                    name='username'
                                    onChange={this.updateFilters}
                                    value={this.state.pagingModel.username} />
                            </Col>
                            <Col xs={12} md={3}>
                                <SelectInput
                                    label='Ruolo'
                                    name='roleId'
                                    onChange={this.updateFilters}
                                    options={this.state.roles}
                                    value={this.state.pagingModel.roleId} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4}>
                                <Button bsStyle='primary' onClick={() => this.search()} >Cerca</Button>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="row">
                    <BootstrapTable data={this.state.pagingModel.items} fetchInfo={{ dataTotalSize: this.state.pagingModel.total }}
                        options={gridOptions} insertRow={true} remote striped hover pagination>
                        <TableHeaderColumn isKey dataField='id' hidden>Id</TableHeaderColumn>
                        <TableHeaderColumn dataField='firstName' dataSort>Nome</TableHeaderColumn>
                        <TableHeaderColumn dataField='lastName' dataSort>Cognome</TableHeaderColumn>
                        <TableHeaderColumn dataField='taxCode' dataSort>C.F.</TableHeaderColumn>
                        <TableHeaderColumn dataField='username' dataSort>Username</TableHeaderColumn>
                        <TableHeaderColumn dataField='role' dataFormat={this.roleInString} dataSort>Ruolo</TableHeaderColumn>
                        <TableHeaderColumn dataField='networkName' dataSort>Socio Sostenitore</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        authenticationState: state.authenticationState,
        commonState: state.commonState,
        pagingModel: state.userState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);
